import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ConfigService } from '../../shared-services/config.service';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-legend-table',
  imports: [CommonModule, FormsModule],
  templateUrl: './legend-table.component.html',
  styleUrl: './legend-table.component.scss',
})
export class LegendTableComponent {
  constructor(
    private configService: ConfigService,
    private keycloakService: KeycloakService
  ) { }
  @Input() data!: any;

  grid: string[][] = [];

  ngOnInit(): void {
    this.buildGrid();
    this.checkEditRoleAccess();
  }
  checkEditRoleAccess() {
    const email =
      this.keycloakService.getKeycloakInstance().idTokenParsed?.['email'];
    this.configService.getRole(email).subscribe((role: any) => {
      if (this.data.editRoles?.includes(role) && this.data.editMode) {
        this.data.editMode = true;
      } else {
        this.data.editMode = false;
      }
    });
  }
  ngOnChanges(): void {
    this.buildGrid();
    this.checkEditRoleAccess();
  }

  private buildGrid(): void {
    if (!this.data?.options || !this.data?.columns) return;

    this.grid = [];
    for (let i = 0; i < this.data.options.length; i += this.data.columns) {
      this.grid.push(this.data.options.slice(i, i + this.data.columns));
    }
  }
}
